import React, { useEffect, useState } from "react";
import {
  Table
} from "react-bootstrap";
import { FaEye, FaPaypal } from "react-icons/fa";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { formatDate } from "../../../helper/helper";
import {
  AcceptRejectApi
} from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import { Loader } from "lucide-react";

const TableList = ({
  userData,
  setUser,
  fetchedGetUsers,
  pageLoader,
  toggleModal,
  currentPage,
  rowsPerPage
}) => {
  const notification = useToastContext();

  // ALL STATE
  const [acceptRejLoader, setAcceptRejLoader] = useState(false);
  const [currentId, setCurrentId] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");

  const handleAcceptRegenct = async (id, newStatus) => {
    setCurrentId(id);
    const status = newStatus ? "active" : "rejected";
    setCurrentStatus(status);
    const requestPayload = { status };

    AcceptRejectApi(requestPayload, id, notification, (loading, error) => {
      setAcceptRejLoader(loading);
      if (!error) {
        fetchedGetUsers();
      }
    });
  };

  return (
    <div className="card overflow-hidden all-tables">
      <div className="">
        <div className="table-responsive">
          <Table responsive="md" className="mb-0">
            <thead>
              <tr>
                <th>S.N</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile No</th>
                <th>Created At</th>
                {/* <th>Status</th> */}
                <th className="text-center">Payment</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            {!pageLoader && userData?.length !== 0 && (
              <tbody>
                {userData &&
                  userData?.length > 0 &&
                  userData?.map((item, index) => {
                    return (
                      <tr>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          <strong className="text-black">{(currentPage - 1) * rowsPerPage + index + 1}</strong>
                        </td>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          {item?.firstName} {item.lastName}
                        </td>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          {item?.email}
                        </td>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          {item?.mobile}
                        </td>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          {formatDate(item?.createdAt)}
                        </td>
                        {/* <td
                          style={
                            item?.status == "rejected"
                              ? {
                                  backgroundColor: "#ffdfdf",
                                  cursor: "not-allowed",
                                }
                              : {}
                          }
                        >
                          <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            checked={item?.status === "active"}
                            onChange={(e) => {
                              if (item?.status !== "rejected") {
                                handleStatusChange(item?._id, e.target.checked);
                              }
                            }}
                          />
                        </td> */}
                        <td
                          className="text-center"
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          <Link
                            to=""
                            className="text-black fs-5 px-1"
                            onClick={() => toggleModal(item)}
                          >
                            <FaPaypal />
                          </Link>
                        </td>
                        <td
                          className="text-center"
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          <div className="d-flex align-items-center justify-content-center gap-1">
                            <button
                              type="button"
                              className="btn btn-success shadow-sm rounded-pill px-2 py-1 d-flex align-items-center"
                              onClick={() =>
                                handleAcceptRegenct(item?._id, true)
                              }
                            >
                              <i
                                className="bi bi-check-circle me-1"
                                style={{ fontSize: "0.8rem" }}
                              ></i>{" "}
                              Approve{" "}
                              {acceptRejLoader &&
                                item?._id == currentId &&
                                currentStatus == "active" && (
                                  <Loader
                                    style={{
                                      marginLeft: "20px",
                                    }}
                                    className="loader"
                                  />
                                )}
                            </button>

                            <button
                              className="btn btn-danger shadow-sm rounded-pill px-2 py-1 d-flex align-items-center"
                              type="button"
                              onClick={() =>
                                handleAcceptRegenct(item?._id, false)
                              }
                              disabled={item?.status == "rejected"}
                              style={
                                item?.status == "rejected"
                                  ? {
                                      cursor: "not-allowed",
                                      background: "light-gray",
                                    }
                                  : { cursor: "pointer" }
                              }
                            >
                              <i
                                className="bi bi-x-circle me-1"
                                style={{ fontSize: "0.8rem" }}
                              ></i>{" "}
                              Deny{" "}
                              {acceptRejLoader &&
                                item?._id == currentId &&
                                currentStatus == "rejected" && (
                                  <Loader
                                    style={{
                                      marginLeft: "20px",
                                    }}
                                    className="loader"
                                  />
                                )}
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            )}

            {userData?.length < 0 && (
              <tbody>
                <tr className="text-center" colspan={7}>
                  <td colspan={7}>No Record Found</td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
      </div>
    </div>
  );
};

export default TableList;
